import React, { useEffect, useState } from 'react'
import { PaymentServices } from './BookingPaymentServices'
import { useForm, FormProvider, Controller, set } from 'react-hook-form';
import { Button, Card, Grid, IconButton, Modal, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { formatDateTime } from '../../../utils/dateUtils';
import Loading from '../../../components/Loader/Loading';
import { Box, Stack } from '@mui/system';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import { BorderColorOutlined, Cancel, CheckCircle, Close, Edit, EditOutlined, RestartAlt, Search } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import Swal from 'sweetalert2';
import AddEditPayment from './AddEditPayment';
import { Helpers } from '../../../services/Helpers';
import noImage from '../../../assets/images/no_image_available.png'

const PaymentList = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  const [paginationModel, setPaginationModel] = useState(
    {
      page: 0,
      pageSize: 20,
      filters: {
        searchKey: "",
        sortBy: 'updatedAt',
        sortType: 'desc',
        filterOptions: [],
      }
    }
  );
  // State management
  const [allRowCount, setAllRowCount] = useState(0);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      field: 'bookingId',
      headerName: 'Booking Id',
      flex: .5,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>{params.value|| 'N/A'}</Typography>
        </Box>
      ),
    },
    {
      field: 'bookingBalanceAmount',
      headerName: 'Booking Balance Amount',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: 'customerPaidAmount',
      headerName: 'Customer Paid',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: 'amountReceived',
      headerName: 'Cudel Received Amount',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: 'paidBalanceAmount',
      headerName: 'Paid Balance Amount',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: `other Detail's`,
      headerName: `other Detail's`,
      flex: 1.75,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, width: '100%' }}>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Tip/Adjustment</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.tipAdjustmentType}</Typography>
          </Box>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>payment Method</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.paymentMethod}</Typography>
          </Box>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Expert Pmt.</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.expertPaymentStatus}</Typography>
          </Box>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Payout Eligibility</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <IconButton size='small' sx={{ p: 0 }}>          
              {
                params.row.isPayoutEligible ?
                  <CheckCircle color='success' sx={{ fontSize: '0.65rem' }} />
                  : <Cancel color='error' sx={{ fontSize: '0.65rem' }} />
              }
            </IconButton>
          </Box>
        </Box>
      ),
    },
    {
      field: 'image',
      headerName: 'Image',
      headerAlign: 'center',
      flex: .5,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%',justifyContent:'center' }}>
          <Box>
            {params.row.image ? (
              // <img
              //   //   src={params.row.images} 
              //   src={`${Helpers.ImagePathUrl()}/booking-payment/sm/${params.row.image}`}
              //   alt={params.row.title}
              //   style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
              // />
              <Button size='small' variant="contained" color="primary" sx={{ fontSize: '0.6rem' }} onClick={() => window.open(`${Helpers.ImagePathUrl()}/booking-payment/${params.row.image}`,'_blank')}>View </Button>
            ) : (
              // <Skeleton variant="rectangular" width={35} height={35} animation={false} />
              <img
                //   src={params.row.images} 
                src={noImage}
                alt={params.row.title+'image_not_available'}
                style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
              />
            )}
          </Box>
        </Box>
      ),
    },
    {
      field: 'createdAt', headerName: 'Created At', headerAlign: 'center', flex: 0.75, filterable: false, sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return formatDateTime(params.row.createdAt);
      },
      renderCell: (params) => (
        <Typography variant="body2" sx={{ width: '100%', textAlign: 'center', color: '#3e3e3e', fontSize: '0.6rem' }}>{formatDateTime(params.row.createdAt)}</Typography>
      ),
    },
    {
      field: 'updatedAt', headerName: 'Updated At', headerAlign: 'center', flex: 0.75, filterable: false, sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return formatDateTime(params.row.updatedAt, 'date');
      },
      renderCell: (params) => (
        <Typography variant="body2" sx={{ width: '100%', textAlign: 'center', color: '#3e3e3e', fontSize: '0.6rem' }}>{params.row.updatedAt ? formatDateTime(params.row.updatedAt) : ''}</Typography>
      ),
    },
    {
      field: "actions", headerName: "Action", sortable: false, filterable: false, flex: .5, renderCell: (params) => {

        return (
          <Box sx={{width:"100%",textAlign:'center'}}>
            <PermissionGuard feature='booking-payment-record' permission='canEdit'>
              <IconButton color='warning' size='small' variant='outlined' onClick={() => handleEdit(params.row)} ><BorderColorOutlined sx={{fontSize:"1rem"}}/></IconButton>
            </PermissionGuard>
          </Box>
        );
      },
      headerAlign: 'center',
    },
  ];
  const fetchList = async ()=>{
    setLoading(true);
    try{
    const response = await PaymentServices.fetchPaymentRecordList({
      page: paginationModel.page,
      limit: paginationModel.pageSize,
      filters: {
        searchKey: paginationModel.filters.searchKey,
        sortBy: paginationModel.filters.sortBy,
        sortType: paginationModel.filters.sortType,
        filterOptions: paginationModel.filters.filterOptions || []
      }
    })
    if(response.success == '1'){
      setList(response.data.list);
      setAllRowCount(response.data.totalItems);
    } 
    else if(response.success == '0'){
      setList([]);      
    }
  } catch(error){
    Swal.fire(error.message,'','error')
  }
    
    setLoading(false);
  }
  useEffect(()=>{
    fetchList();
  },[paginationModel]);

  const handlePaginationChange = (newPagination) => {
    setPaginationModel(prev => ({
      ...prev,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    }));
  };
  // Form handling for filters
    const filterFormMethod = useForm();
    const { control, handleSubmit, reset, setValue, getValues, formState: { errors }, watch } = filterFormMethod;
  
    // Filter submission handler
    function onSubmit(data) {
      const filtersData = getValues();
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          searchKey: filtersData.searchKey,
        }
      }));
    }
  
    // Clear filters handler
    const clearFilters = () => {
      reset();
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          searchKey: "",
          // status: 1,
          sortBy: 'createdAt',
          sortType: 'desc',
          filterOptions: [ ]
        }
      }));
  
      // Trigger clear for MultiColumnFilter
      setClearMultiFilter(true);
  
      // Reset the clear trigger after a short delay
      setTimeout(() => setClearMultiFilter(false), 100);
    };   
  
    /************************  Advance Filter **************************** */
  
  
    const [clearMultiFilter, setClearMultiFilter] = useState(false);
  
    const filterableColumns = [
      {
        key: 'paymentMethod',
        label: 'Payment Method',
        type: 'select',
        options: [
          { value: 'CASH', label: 'CASH' },
          { value: 'UPI_QR', label: 'UPI_QR' },
          { value: 'APP_RAZORPAY', label: 'APP_RAZORPAY' },
        ]
      },
      {
        key: 'expertPaymentStatus',
        label: 'Expert Payment Status',
        type: 'select',
        options: [
          { value: 'TRANSFERRED_FULL', label: 'TRANSFERRED_FULL' },
          { value: 'PAID_FEES_ONLY', label: 'PAID_FEES_ONLY' },
          { value: 'PAID_PARTIAL', label: 'PAID_PARTIAL' },
          { value: 'NOT_TRANSFERRED', label: 'NOT_TRANSFERRED' },
        ]
      },
      {
        key: 'isPayoutEligible',
        label: 'Payout Eligibility',
        type: 'select',
        options: [
          { value: 'true', label: 'Eligible' },
          { value: 'false', label: 'Not-Eligible' }
        ]
      },
      {
        key: 'tipAdjustmentType',
        label: 'Tip/Adjustment Type',
        type: 'select',
        options: [
          { value: 'NONE', label: 'NONE' },
          { value: 'TIP', label: 'TIP' },
          { value: 'ADJUSTMENT', label: 'ADJUSTMENT' }
        ]
      },
      {
        key: 'referenceNumber',
        label: 'Reference Number',
        type: 'text'
      },
      {
        key: 'bookingNumber',
        label: 'Booking Number',
        type: 'text'
      },
      {
        key: 'createdAt',
        label: 'Created Date',
        type: 'date'
      },
      {
        key: 'updatedAt',
        label: 'Updated Date',
        type: 'date'
      }
    ];
  
    const handleApplyFilter = (filterData) => {
      // Process filter data
      console.log(filterData);
      setPaginationModel({
        ...paginationModel,
        page: 0, // Reset to first page when applying new filters
        filters: {
          ...paginationModel.filters,
          // Convert MultiColumnFilter options to a format your backend can understand
          filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
        }
      });
    }
  
    /************* quick search related **************/
    const [quickFilterText, setQuickFilterText] = useState('');
    // Properly structured filter model
    const [filterModel, setFilterModel] = useState({
      items: [],
      quickFilterValues: []
    });
  
    // Update filter model when quick filter text changes
    useEffect(() => {
      setFilterModel(prevModel => ({
        ...prevModel,
        quickFilterValues: quickFilterText ? [quickFilterText] : []
      }));
    }, [quickFilterText]);
  
    /******************* Sorting model  ******************************/
    const [sortModel, setSortModel] = useState([
      {
        field: paginationModel.filters.sortBy,
        sort: paginationModel.filters.sortType,
      },
    ]);
  
    const handleSortingChange = (newSortModel) => {
      console.log("new sort model", newSortModel);
      if (newSortModel && newSortModel.length > 0) {
        setSortModel(newSortModel);
        setPaginationModel(prev => ({
          ...prev,
          filters: {
            ...prev.filters,
            sortBy: newSortModel[0].field,
            sortType: newSortModel[0].sort
          }
        }));
      }
    }
    const [isEdit,setIsEdit] = useState(false);
    const [selectedPaymentRecord,setSelectedPaymentRecord] = useState(null);
    const handleModalClose = ()=>{
      setIsEdit(false);
      setSelectedPaymentRecord(null);
      fetchList();
    }
    const handleEdit = (record)=>{
      setSelectedPaymentRecord({
        id: record.id,
        bookingId : record.bookingId,
        bookingNumber:record.booking.bookingNumber,
        bookingAmount:record.booking.total,
        bookingBalanceAmount : record.bookingBalanceAmount,
        customerPaidAmount : record.customerPaidAmount,
        image : record.image,
        paymentMethod : record.paymentMethod,
        expertPaymentStatus : record.expertPaymentStatus,
        amountReceived : record.amountReceived,
        isPayoutEligible : record.isPayoutEligible,
        referenceNumber : record.referenceNumber,
        customerFeedback : record.customerFeedback,
        paidBalanceAmount : record.paidBalanceAmount,
        tipAdjustmentType : record.tipAdjustmentType,
        paymentRemarks : record.paymentRemarks,
      });
      setIsEdit(true);
    }
  return (
    <>
      {loading && <Loading />}
      <Card sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff" }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <MultiColumnFilter
                filterableColumns={filterableColumns}
                onApplyFilter={handleApplyFilter}
                externalClear={clearMultiFilter}
                defaultFilterOptions={paginationModel.filters.filterOptions}
                alwaysKeepDefaultFilterOption={true}
              />
              {/* <ExportAll
                paginationModel={paginationModel}
                columns={columns}
              /> */}
            </Box>
            {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} />             */}
            <Box sx={{width:{xs:'75%',sm:'40%',md:'30%',lg:'25%'}}}>
              {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
              <FormProvider {...filterFormMethod}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={1} sx={{ p: '.5%' }}>
                    <Grid item xs={9} lg={8}>
                      <Controller
                        name="searchKey"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter keywords to search "
                            // label="Search"
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                paddingLeft: '0px',
                              }
                            }}
                            InputProps={{  // Changed from slotProps to InputProps
                              inputProps: {
                                style: {
                                  height: '0.6rem',
                                  // textTransform: 'uppercase',
                                  fontSize: 'x-small'
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={3} lg={4}>
                      <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                        <IconButton
                          size='small'
                          color="primary"
                          type="submit"
                          sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                        >
                          <Search sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Clear All Filters">
                        <IconButton
                          size='small'
                          color="primary"
                          sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                          onClick={clearFilters}
                        >
                          <RestartAlt sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </form>
              </FormProvider>
            </Box>
            
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
              minWidth: isSmallScreen && (col.minWidth || 180), // Set a minimum width to avoid overlap
            }))}
            rowCount={allRowCount}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}
            filterModel={filterModel}


            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loading}
            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,   
              loadingOverlay: Loading,
              noRowsOverlay: ()=>(<NoRowsLayout message={"No Record Found"}/>),
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
              lineHeight: 1,
              borderTopLeftRadius:0,
              borderLeft:0,
              '& .MuiDataGrid-cell': {
                // first cell borderLeft:0
                
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                // borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p: 0,
                // height: 'fit-content',
                minHeight: '0 !important',
                height: '2rem'
              },
              '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
          />
        </Box>
      </Card>
      {/* ========== Payment Entry Details Modal =========== */}
      <Modal
        open={isEdit}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%"},
            minHeight: '25%',
            maxHeight: '90%'
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              New Payment Entry
            </Typography>
            <IconButton
              size='small'
              onClick={handleModalClose}
              sx={{ p: 0 }}
              color='error'
            >
              <Close sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
            </IconButton>
          </Box>
          {/* <PaymentDescription/> */}
          <AddEditPayment paymentRecordData={selectedPaymentRecord} isEdit={isEdit} closePaymentEntryDialog={handleModalClose}/>
        </Box>
      </Modal>
    </>
  )
}

export default PaymentList